import { EntityTemplate, Field, ValueType } from "../../../models/workshop/common"
import { TFunction } from "i18next"
import { safeJsonParse } from "../../../utility/common/safeJsonParse"
import { Channel } from "../../../models/channel"

const tNamespace = "workshop:form."

export const getDefaultFields = (
    t: TFunction,
    title = "",
    isCreatingOrUpdating = false,
    channelEntity?: EntityTemplate
): Field[] => {
    const channel = safeJsonParse<Channel | undefined>(channelEntity?.Template ?? "", undefined)

    const titleField: Field = {
        Id: "title",
        Title: t(`${tNamespace}title`),
        Value: title,
        IsRequired: true,
        TabId: "",
        GroupId: "",
        TypeValue: {
            Case: ValueType.STRING,
            Fields: ""
        }
    }

    const defaultAgentField: Field = {
        Id: "default_agent",
        Title: t(`${tNamespace}default-agent`),
        Value: channel?.Params["default_agent"] ?? "",
        IsRequired: true,
        TabId: "",
        GroupId: "",
        TypeValue: {
            Case: ValueType.AGENT,
            Fields: ""
        }
    }

    if (isCreatingOrUpdating && channel) {
        return [titleField, defaultAgentField]
    }

    return [titleField]
}
